export interface ForecastUserStats {
  createdByUserId?: number;
  creationDate?: Date;
  forecastOverviewId?: number;
  id?: number;
  lastModified?: Date;
  statsAction?: ForecastStatusAction;
}

export enum ForecastStatusAction {
  Downloaded = 'DOWNLOADED',
  Shared = 'SHARED'
}
